import { Button as ButtonBase } from '@mui/material';

interface Props {
  title: string;
  type?: string;
  className?: string;
  classTextName?: string;
  onClick?: () => void;
  variant: 'primary' | 'secondary' | 'tertiary' | 'success' | 'error' | 'info' | 'warning';
  disabled?: boolean;
  iconStart?: any;
  iconEnd?: any;
}

export const Button = ({
  title,
  onClick,
  disabled = false,
  type = 'button',
  className = '',
  variant = 'primary',
  iconStart = <></>,
  iconEnd = <></>,
  classTextName = '',
}: Props) => {
  const buttonProps = {
    variant: ['primary', 'success', 'warning', 'tertiary'].includes(variant)
      ? 'contained'
      : 'outlined',
    color:
      variant === 'primary'
        ? 'primary'
        : variant === 'secondary'
          ? 'secondary'
          : variant === 'warning'
            ? 'warning'
            : variant,
    textColor: ['primary', 'success'].includes(variant) ? 'white' : 'black',
    borderColor: variant === 'secondary' ? '1px solid #9d9d9d' : '',
  };

  return (
    // @ts-ignore - .
    <ButtonBase
      startIcon={iconStart}
      endIcon={iconEnd}
      disabled={disabled}
      type={type}
      className={className}
      variant={buttonProps.variant}
      onClick={onClick}
      color={buttonProps.color}
      sx={{
        padding: 1.3,
        borderRadius: '5px',
        textTransform: 'none',
        color: buttonProps.textColor,
        fontFamily: 'inherit',
        fontSize: '16px',
        lineHeight: '1.2',
        border: buttonProps.borderColor,
        boxShadow: '0px 10px 40px 0px rgba(0, 0, 0, 0.2)',
        background:
          ['primary', 'success'].includes(variant)
            ? 'primary'
            : variant === 'secondary'
              ? '#E8E8E8'
              : 'success',
        transition: 'background 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
          transitionDelay: '.1s',
          background:
            ['primary', 'success'].includes(variant)
              ? 'primary'
              : variant === 'secondary'
                ? '#dcdcdc'
                : 'transparent',
          boxShadow: '0px 10px 40px 0px rgba(0, 0, 0, 0.3)',
        },
        '&:focus': {
          boxShadow: '0px 20px 40px 0px rgba(0, 0, 0, 0.3)',
        },
        '&.Mui-disabled': {
          opacity: 0.5,
          color: `${variant !== 'primary' ? '#939090' : '#f2f2f2'}`,
          backgroundColor: `${variant === 'primary' ? '#939090' : '#f2f2f2'}`,
        },
      }}
    >
      <p className={`${classTextName}`}>{title}</p>
    </ButtonBase>
  );
};
